import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "other"
}
const _hoisted_4 = { class: "asset-title" }
const _hoisted_5 = { class: "file-type" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "condition" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_popup = _resolveComponent("popup")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    isDisabled: _ctx.isDisabled,
    current: 2,
    prePathName: "pi-risk"
  }, {
    default: _withCtx(() => [
      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "title" }, "准则", -1)),
      _cache[42] || (_cache[42] = _createElementVNode("p", { class: "tips" }, " 请选择以下任何一项或多于一项，拥有的投资组合在本专业投资者声明书（「声明书」）签署当日不少于港币8,000,000 ", -1)),
      _createVNode(_component_van_field, {
        name: "checkboxGroup",
        rules: [{ required: true, message: '请至少选择一项' }],
        class: "checkbox"
      }, {
        input: _withCtx(() => [
          _createVNode(_component_van_checkbox_group, {
            modelValue: _ctx.form.assetChecked,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.assetChecked) = $event)),
            class: "checkbox",
            onChange: _ctx.changeChecked
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetCriterionList, (item) => {
                return (_openBlock(), _createBlock(_component_van_checkbox, {
                  key: item.value,
                  name: item.value,
                  shape: "square"
                }, {
                  icon: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(
                  `iconfont ${
                    _ctx.form.assetChecked.includes(item.value)
                      ? 'icon-duoxuanxuanzhong'
                      : 'icon-duoxuanweixuanzhong'
                  }`
                )
                    }, null, 2)
                  ]),
                  default: _withCtx(() => [
                    (item.value === _ctx.PiAssetsCriterionCode.PI_ASSETS_CRITERION_CODE_3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                          _createTextVNode(_toDisplayString(item.name.split('联系者')[0].split(')')[1]), 1),
                          _createElementVNode("span", {
                            class: "yellow",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPerson = true))
                          }, "联系者"),
                          _createTextVNode(_toDisplayString(item.name.split('联系者')[1]), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.name.split(')')[1]), 1))
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]),
        _: 1
      }),
      (_ctx.form.assetChecked.includes(_ctx.PiAssetsCriterionCode.PI_ASSETS_CRITERION_CODE_4))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_van_field, {
              name: "attestation1",
              modelValue: _ctx.form.attestation1,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.attestation1) = $event)),
              modelModifiers: { trim: true },
              placeholder: "请注明",
              rules: [{ required: true, message: '请注明' }]
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "title" }, "上传资产凭证", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, [
          _cache[28] || (_cache[28] = _createTextVNode("证明材料可多选 ")),
          _createElementVNode("i", {
            class: "iconfont icon-tishi",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTip = true))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetOption, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.value,
            class: _normalizeClass(_ctx.isActive(item)),
            onClick: ($event: any) => (_ctx.selectType(item))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.name), 1)
          ], 10, _hoisted_6))
        }), 128))
      ]),
      _cache[44] || (_cache[44] = _createElementVNode("p", { class: "tips" }, " 请上传一个或多个，拥有由证券、存款及现金组成的不少于港币8,000,000投资组合证明 。 ", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_van_field, {
          name: "uploader",
          rules: [{ required: true, message: '请上传凭证' }]
        }, {
          input: _withCtx(() => [
            _createVNode(_component_van_uploader, {
              modelValue: _ctx.fileList,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fileList) = $event)),
              "before-read": _ctx.beforeRead,
              accept: ".pdf,image/*",
              "max-count": "5",
              "preview-size": "86",
              readonly: _ctx.isApp,
              deletable: false
            }, {
              "preview-cover": _withCtx((file) => [
                _createElementVNode("div", {
                  class: "preview-cover",
                  onClick: _withModifiers(($event: any) => (_ctx.handleDel(file)), ["stop"])
                }, _cache[29] || (_cache[29] = [
                  _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                ]), 8, _hoisted_7)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "upload-style",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.uploadToApp && _ctx.uploadToApp(...args)))
                }, _cache[30] || (_cache[30] = [
                  _createElementVNode("i", { class: "iconfont icon-jia-tianchong" }, null, -1),
                  _createElementVNode("p", null, "上传凭证", -1)
                ]))
              ]),
              _: 1
            }, 8, ["modelValue", "before-read", "readonly"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: "sample",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.viewExp && _ctx.viewExp(...args)))
      }, "查看正确示例"),
      _createElementVNode("div", _hoisted_8, [
        _cache[33] || (_cache[33] = _createElementVNode("p", null, "a.非“其他”证明材料，凭证需包含以下内容：", -1)),
        _createElementVNode("p", null, [
          _cache[32] || (_cache[32] = _createTextVNode(" 1、发出")),
          _createElementVNode("span", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.custShow = true))
          }, [
            _cache[31] || (_cache[31] = _createTextVNode("保管人")),
            _createElementVNode("i", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.custShow = true)),
              class: "iconfont icon-tishi"
            })
          ])
        ]),
        _cache[34] || (_cache[34] = _createElementVNode("p", null, "2、本人姓名，不能为其他人", -1)),
        _cache[35] || (_cache[35] = _createElementVNode("p", null, "3、三个月内的发出日期", -1)),
        _cache[36] || (_cache[36] = _createElementVNode("p", null, "4、总值超过800万港元或等值外币", -1)),
        _cache[37] || (_cache[37] = _createElementVNode("p", null, [
          _createTextVNode(" b.如证明材料含“其他”"),
          _createElementVNode("span", { style: {"color":"#ffb400"} }, "除上述a凭证资料还需包含"),
          _createTextVNode("以下内容： ")
        ], -1)),
        _cache[38] || (_cache[38] = _createElementVNode("p", null, "1、全资100%持有公司的资产证明、公司的股权证明文件", -1)),
        _cache[39] || (_cache[39] = _createElementVNode("p", null, "c.如有任何疑问,请致电(852)2153 3838与我们查询。", -1)),
        _cache[40] || (_cache[40] = _createElementVNode("p", null, "d.以上一切解释权归金马证券所有", -1))
      ]),
      _createVNode(_component_popup, {
        show: _ctx.showPerson,
        "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showPerson) = $event)),
        height: "60%",
        onClosePopup: _cache[10] || (_cache[10] = () => (_ctx.showPerson = false)),
        onClickOverlay: _cache[11] || (_cache[11] = () => (_ctx.showPerson = false)),
        title: '联系者',
        content: '就任何个人而言，有联系者指该人的配偶或任何子女。'
      }, null, 8, ["show"]),
      _createVNode(_component_popup, {
        show: _ctx.showTip,
        "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showTip) = $event)),
        height: "80%",
        onClosePopup: _cache[13] || (_cache[13] = () => (_ctx.showTip = false)),
        onClickOverlay: _cache[14] || (_cache[14] = () => (_ctx.showTip = false)),
        title: '',
        content: '仅在上方“准则”勾选第三项，这里默认选中含“其他”。'
      }, null, 8, ["show"]),
      _createVNode(_component_popup, {
        show: _ctx.portfolioShow,
        "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.portfolioShow) = $event)),
        height: "90%",
        onClosePopup: _cache[16] || (_cache[16] = () => (_ctx.portfolioShow = false)),
        onClickOverlay: _cache[17] || (_cache[17] = () => (_ctx.portfolioShow = false)),
        title: _ctx.title,
        content: _ctx.content
      }, null, 8, ["show", "title", "content"]),
      _createVNode(_component_popup, {
        show: _ctx.show2,
        "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.show2) = $event)),
        height: "80%",
        onClosePopup: _cache[19] || (_cache[19] = () => (_ctx.show2 = false)),
        onClickOverlay: _cache[20] || (_cache[20] = () => (_ctx.show2 = false)),
        title: _ctx.arTitle,
        content: _ctx.arContent
      }, null, 8, ["show", "title", "content"]),
      _createVNode(_component_popup, {
        show: _ctx.assetTipPicker,
        "onUpdate:show": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.assetTipPicker) = $event)),
        height: "80%",
        onClosePopup: _cache[22] || (_cache[22] = ($event: any) => (_ctx.assetTipPickerToggle(false))),
        onClickOverlay: _cache[23] || (_cache[23] = ($event: any) => (_ctx.assetTipPickerToggle(false))),
        title: _ctx.arTitle,
        content: _ctx.arContent
      }, null, 8, ["show", "title", "content"]),
      _createVNode(_component_popup, {
        show: _ctx.custShow,
        "onUpdate:show": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.custShow) = $event)),
        height: "80%",
        onClosePopup: _cache[25] || (_cache[25] = () => (_ctx.custShow = false)),
        onClickOverlay: _cache[26] || (_cache[26] = () => (_ctx.custShow = false)),
        title: "保管人",
        content: _ctx.custContent
      }, null, 8, ["show", "content"]),
      _createVNode(_component_van_action_sheet, {
        show: _ctx.fileActionState,
        "onUpdate:show": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.fileActionState) = $event)),
        actions: _ctx.actionsList,
        "cancel-text": "取消",
        "close-on-click-action": "",
        onSelect: _ctx.onFileSelect
      }, null, 8, ["show", "actions", "onSelect"])
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled"]))
}